/* ===========================================================
   ALMOND — script partagé pour les sections almond-*.liquid
   Fonctionne pour plusieurs instances de section sur la même
   page, et se ré-initialise dans l'éditeur de thème Shopify
   (shopify:section:load) quand une section est ajoutée/éditée.
   =========================================================== */
(function () {
  function initReveal(root) {
    var items = (root || document).querySelectorAll('.almond-page .reveal:not([data-almond-observed])');
    if (!items.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.classList.add('in');
      });
    }, { threshold: 0.15 });
    items.forEach(function (el) {
      el.setAttribute('data-almond-observed', 'true');
      io.observe(el);
    });
  }

  function initCarousels(root) {
    var buttons = (root || document).querySelectorAll('.almond-page .track-prev:not([data-almond-bound]), .almond-page .track-next:not([data-almond-bound])');
    buttons.forEach(function (btn) {
      btn.setAttribute('data-almond-bound', 'true');
      btn.addEventListener('click', function () {
        var track = document.getElementById(btn.dataset.target);
        if (!track || !track.firstElementChild) return;
        var amount = track.firstElementChild.getBoundingClientRect().width + 22;
        track.scrollBy({ left: btn.classList.contains('track-next') ? amount : -amount, behavior: 'smooth' });
      });
    });
  }

  function initHero(root) {
    var heroes = (root || document).querySelectorAll('.almond-page .hero-slideshow:not([data-almond-bound])');
    heroes.forEach(function (hero) {
      hero.setAttribute('data-almond-bound', 'true');
      var slides = hero.querySelectorAll('.hero-slide');
      var dots = hero.querySelectorAll('.hero-dots button');
      var prev = hero.querySelector('.hero-prev');
      var next = hero.querySelector('.hero-next');
      if (slides.length < 2) return;
      var index = 0;
      var timer;
      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, idx) { s.classList.toggle('active', idx === index); });
        dots.forEach(function (d, idx) { d.classList.toggle('active', idx === index); });
      }
      function restart() {
        clearInterval(timer);
        timer = setInterval(function () { show(index + 1); }, 7000);
      }
      if (next) next.addEventListener('click', function () { show(index + 1); restart(); });
      if (prev) prev.addEventListener('click', function () { show(index - 1); restart(); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { show(parseInt(d.dataset.i, 10)); restart(); });
      });
      restart();
    });
  }

  function initAll(root) {
    initReveal(root);
    initCarousels(root);
    initHero(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  // Ré-initialise quand une section Almond est ajoutée/éditée dans le customizer
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
